export default {
    //获取路由名称
    getRouterName(states) {
        return states.routerName;
    },
    //判断loginModal的显示与隐藏
    getLoginStatus(status) {
        return status.loginStatus
    },
    //获取个人信息
    getUserInfo(states) {
        return states.userInfo;
    },
    //获取面包屑list
    getBreadcrumbList(states) {
        return states.breadcrumbList;
    },
    //获取当前页面高度
    getInnerHeight(states) {
        return states.InnerHeight;
    },
    //获取当前页面高度
    getFullStatus(states) {
        return states.FullStatus;
    },
}



// WEBPACK FOOTER //
// ./src/store/navigation/getters.js